/**
 * ENVIRONMENT: PRODUCTION
 * MODULE: Central Application Layout Shell (Fixed Viewport)
 * PATH: src/layout/index.js
 */

import React, { useState } from 'react';
import { Layout } from "antd";
import AppSidebar from "layout/AppSidebar";
import AppHeader from "./AppHeader";
import "./AppLayout.css";

const { Content } = Layout;

const AppLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <Layout className="enterprise-root-viewport">
      {/* 1. Fixed Left Sider */}
      <AppSidebar 
        isCollapsed={isCollapsed}
        toggleCollapse={() => setIsCollapsed(!isCollapsed)}
      />

      {/* 2. Main Right Column: Locked to 100vh */}
      <Layout className={`enterprise-main-column ${isCollapsed ? 'collapsed' : ''}`}>
        {/* Pinned Top Navbar - Never Moves */}
        <AppHeader />

        {/* Dedicated Scroll Container - Only This Area Scrolls */}
        <Content className="enterprise-scrollable-content">
          <div className="content-inner-wrapper">
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;